var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWellbeing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7292 21.9598C39.8532 25.0818 39.8532 30.1478 36.7292 33.2718L25.4152 44.5858C24.6352 45.3658 23.3672 45.3658 22.5872 44.5858L11.2732 33.2718C8.14918 30.1478 8.14918 25.0818 11.2732 21.9578C14.3972 18.8338 19.4632 18.8338 22.5872 21.9578L23.9992 23.3718L25.4152 21.9578C28.5392 18.8338 33.6052 18.8338 36.7292 21.9578V21.9598ZM24.0012 1.99982C28.4212 1.99982 32.0012 5.57982 32.0012 9.99982C32.0012 14.4198 28.4212 17.9998 24.0012 17.9998C19.5812 17.9998 16.0012 14.4198 16.0012 9.99982C16.0012 5.57982 19.5812 1.99982 24.0012 1.99982Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeing);
export default __webpack_public_path__ + "static/media/wellbeing.452c68abf31f56103a224868a06ac613.svg";
export { ForwardRef as ReactComponent };